/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeSXIcon24Solid = forwardRef('MediaAudioVolumeSXIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "m5.571 8 4.941-4.323c.97-.849 2.488-.16 2.488 1.129v14.388c0 1.29-1.518 1.978-2.488 1.13L5.572 16H3a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h2.571Z" }),
        React.createElement("path", { d: "M15.293 8.293a1 1 0 0 1 1.414 0L19 10.586l2.293-2.293a1 1 0 1 1 1.414 1.414L20.414 12l2.293 2.293a1 1 0 1 1-1.414 1.414L19 13.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L17.586 12l-2.293-2.293a1 1 0 0 1 0-1.414Z" })));
});
